import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import IntegrationsConnector from "../../components/admin/integration/IntegrationsConnector";
import { PageContainer } from "@outpave/ds";
import { useNavBreadcrumbs } from "hooks/useNavBreadcrumbs";

const Integrations: React.FC = () => {
  const { t } = useTranslation();
  const breadcrumbs = useNavBreadcrumbs(t("Integrations"));
  // No debounce: this filters a catalogue already in memory, not a query.
  const [query, setQuery] = useState("");

  return (
    <PageContainer
      title={t("Integrations")}
      breadcrumbs={breadcrumbs}
      // The cards are their own surfaces; wrapping them in the shell's card
      // puts a surface inside the same surface.
      wrapped={false}
      search={{
        value: query,
        onChange: setQuery,
        placeholder: t("Search platforms"),
      }}
    >
      <IntegrationsConnector query={query} />
    </PageContainer>
  );
};

export default Integrations;
